import { Box, Link, Typography } from '@mui/material'
import { Text } from 'components'
import { color } from 'config/color'
import ArticleImg1 from 'assets/images/article_img_1.png'
import ArticleImg2 from 'assets/images/article_img_2.png'
import type React from 'react'


const ARTICLES = [
  { title: 'Water Conservation Tips', image: ArticleImg1, link: 'https://delcowater.org/water-conservation/' },
  { title: 'Understanding Your Bill', image: ArticleImg2, link: 'https://delcowater.org/understanding-your-bill/' }
]

export const CustomBox: React.FC = () => {
  return (
    <Box bgcolor={color.white} borderRadius={1} height="100%">
      <Box p={3} display="flex" flexDirection="column" gap={3}>
        <Text color={color.grey[900]} fontSize='18px' fontWeight='600'>
          Quick Tips
        </Text>
        {ARTICLES.map((item, index) =>
          <Box key={index} bgcolor={color.background[50]} display='flex' alignItems="center" p={2} gap={2}>
            <Box component="img" src={item.image} />
            <Box>
              <Typography fontWeight='700' fontSize='16px' color={color.grey[900]}> {item.title} </Typography>
              <Link sx={{ color: color.background[900], textDecoration: 'none', cursor: 'pointer' }} onClick={() => window.open(item.link, '_blank')}>Read More</Link>
            </Box>
          </Box>
        )}
      </Box>
    </Box >

  )
}
